import { theme } from '@salecycle/ui-component-library';

export const getValidationItemHeading = (rule, t) => {
  switch (rule) {
    case 'browse_currency':
    case 'missing_image_alt_tags':
    case 'missing_image_src_tags':
    case 'unsubscribe':
    case 'email_tracking_unsubscribe':
    case 'webview_link':
    case 'use_of_hardcoded_year_instead_of_helper':
    case 'duplicate_question_mark_in_links':
    case 'empty_links':
    case 'client_name':
    case 'vml_background_images':
    case 'vml_button_links':
    case 'vml_button_text':
      return t(`trackingLinks:templateLevel.rightPanel.validation.validationItemsHeading.${rule}`);
    default:
      return t(`trackingLinks:templateLevel.rightPanel.validation.validationItemsHeading.ruleDoesNotExist`);
  }
};

export const getValidationItemTooltipContent = (rule, t) => {
  switch (rule) {
    case 'browse_currency':
    case 'missing_image_alt_tags':
    case 'missing_image_src_tags':
    case 'unsubscribe':
    case 'email_tracking_unsubscribe':
    case 'webview_link':
    case 'use_of_hardcoded_year_instead_of_helper':
    case 'duplicate_question_mark_in_links':
    case 'empty_links':
    case 'client_name':
    case 'vml_background_images':
    case 'vml_button_links':
    case 'vml_button_text':
      return t(`trackingLinks:templateLevel.rightPanel.validation.validationItemsTooltip.${rule}`, {
        // Temporarily change the interpolation suffix/prefix to allow display of '{{' and '}}' in the tooltip.
        interpolation: {
          suffix: '###',
          prefix: '###',
        },
      });
    default:
      return t(`trackingLinks:templateLevel.rightPanel.validation.validationItemsTooltip.ruleDoesNotExist`);
  }
};

export const getValidationItemDescription = (rule, t) => {
  switch (rule) {
    case 'browse_currency':
    case 'missing_image_alt_tags':
    case 'missing_image_src_tags':
    case 'unsubscribe':
    case 'email_tracking_unsubscribe':
    case 'webview_link':
    case 'use_of_hardcoded_year_instead_of_helper':
    case 'duplicate_question_mark_in_links':
    case 'empty_links':
    case 'client_name':
    case 'vml_background_images':
    case 'vml_button_links':
    case 'vml_button_text':
      return t(`trackingLinks:templateLevel.rightPanel.validation.validationItemsDescription.${rule}`, {
        // Temporarily change the interpolation suffix/prefix to allow display of '{{' and '}}' in the tooltip.
        interpolation: {
          suffix: '###',
          prefix: '###',
        },
      });
    default:
      return t(`trackingLinks:templateLevel.rightPanel.validation.validationItemsDescription.ruleDoesNotExist`);
  }
};

export const getBadgeText = (severity, t) => {
  switch (severity) {
    case 'fail':
      return t('trackingLinks:templateLevel.rightPanel.validation.fail');
    case 'warning':
      return t('trackingLinks:templateLevel.rightPanel.validation.warning');
    case 'pass':
      return t('trackingLinks:templateLevel.rightPanel.validation.pass');
  }
};

export const getBadgeColor = severity => {
  switch (severity) {
    case 'fail':
      return theme.vars.newColor.red2;
    case 'warning':
      return theme.vars.newColor.orange2;
    case 'pass':
      return theme.vars.newColor.green2;
  }
};

export const isObjectEmpty = obj => {
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) return false;
  }
  return true;
};
